import { Container, styled } from "@mui/material";

const CustomContainer = styled(Container)(({ theme }) => ({
  minHeight: "100%",
  paddingBottom: theme.spacing(3),
  paddingTop: theme.spacing(3)
}));

export default CustomContainer;